import React from 'react';
import { UploadPhotoOrderGuide } from '@/experiences/sales-portal/components/create-order-guide/upload-photo-order-guide';
import { useCreateOrderGuideFromImage } from '@/experiences/sales-portal/blocs/hooks/use-create-order-guide-from-image';

interface UploadPhotoOrderGuideModalContainerProps {
  isOpen: boolean;
  onClose: () => void;
  restaurantName?: string;
  restaurantUUID: string;
  supplierUUID: string;
}

export const UploadPhotoOrderGuideModalContainer: React.FC<
  UploadPhotoOrderGuideModalContainerProps
> = ({ isOpen, onClose, restaurantName, restaurantUUID, supplierUUID }) => {
  const {
    addImages,
    back,
    generate,
    items,
    processImages,
    removeImage,
    reset,
    selectedImages,
    step,
  } = useCreateOrderGuideFromImage({ restaurantUUID, supplierUUID });

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleGenerate = async () => {
    if (await generate()) {
      handleClose();
    }
  };

  return (
    <UploadPhotoOrderGuide
      isOpen={isOpen}
      items={items}
      onAddImages={addImages}
      onBack={back}
      onClose={handleClose}
      onGenerate={handleGenerate}
      onRemoveImage={removeImage}
      onScan={processImages}
      restaurantName={restaurantName}
      selectedImages={selectedImages}
      step={step}
    />
  );
};
